//@ts-nocheck1
import { useOutsideClick } from 'outsideclick-react';
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useRouter, usePathname } from 'next/navigation';
import { bindActionCreators } from 'redux';
import * as bondsAction from '@/redux/actions/bonds';
// import { EXIST_LOCAL_STORAGE } from "../services/constants";
// import { getEncryptedText, getStorage } from "../services/helperFunctions";
import FullTextLazyLoading from './FullTextLazyLoading';
import { getCookie } from '@/services/helperFunctions';
import { EXIST_LOCAL_STORAGE } from '@/services/constants';

interface FullTextSearchProps {
  isMobile: boolean;
  isBoandsLoader: boolean;
  closeFulltextForMobile: () => void;
  getFullText?: any;
  getFulltextHandle?: any;
  bondsFulltextHandle?: any;
  toggleFullTextForMobile?: any;
}

const FullTextSearch: React.FC<FullTextSearchProps> = ({
  isMobile,
  isBoandsLoader,
  closeFulltextForMobile,
  getFullText,
  getFulltextHandle,
  bondsFulltextHandle,
  toggleFullTextForMobile,
}) => {
  useEffect(() => {
    let trigger = false;
    getFulltextHandle({}, trigger);
  }, []);
  const pathname = usePathname();
  const router = useRouter();
  const [placeholder, setPlaceholder] = useState('Search Bond, Country, ISIN, Coupon Rate, Issuer');
  const [showDropdown, setShowDropdown] = useState(false);
  const [value, setValue] = useState('');
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const UserId = useMemo(() => getCookie(EXIST_LOCAL_STORAGE.USER_ID) || '', []);

  const handleInputFocus = useCallback(() => setPlaceholder('Please enter 4 or more characters to search'), []);

  const handleClickFulltext = useCallback(() => {
    let trigger = false;
    getFulltextHandle({}, trigger);
  }, [getFulltextHandle]);

  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleFullTextSearch = useCallback(
    (e: any) => {
      const inputValue = e.target.value;
      setValue(inputValue);
      setData([]);
      const body = {
        params: {
          user_id: UserId,
          fulltext: inputValue.trim(),
          page_no: 1,
          per_page: 20,
        },
      };
      setShowDropdown(true);
      setLoading(true);
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
      }

      const newTimer = setTimeout(() => {
        if (e.target.value !== '' && e.target.value.length > 3) {
          getFullText(body).then((res: any) => {
            setData(res?.bonds);
            setLoading(false);
          });
        }
      }, 800);
      timerRef.current = newTimer;
    },
    [getFullText, UserId]
  );

  const handleOutsideClick = useCallback((e: any) => {
    setPlaceholder('Search Bond, Country, ISIN, Coupon Rate, Issuer');
    if (timerRef?.current) clearTimeout(timerRef.current);
    setShowDropdown(false);
    setValue('');
    setData([]);
  }, []);

  const handleSubmit = useCallback(
    (e: any) => {
      e.preventDefault();
      if (!value.trim()) return;

      closeFulltextForMobile();

      if (timerRef?.current) clearTimeout(timerRef.current);

      if (!pathname.includes('/screener')) {
        router.push('/screener');
      }

      const body = {
        params: {
          user_id: UserId,
          fulltext: value.trim(),
          page_no: 1,
          per_page: 20,
        },
      };

      const trigger = true;
      getFulltextHandle(body, trigger);
      setShowDropdown(false);
      setValue('');
      setData([]);
    },
    [closeFulltextForMobile, getFulltextHandle, pathname, router, UserId, value]
  );

  const ref = useOutsideClick(handleOutsideClick);

  const handleBondNameClick = useCallback(
    (isin: string) => {
      const encodedURL = `/bonds/${isin}`;
      router.push(encodedURL);
      setShowDropdown(false);
      setValue('');
      setData([]);
      if (toggleFullTextForMobile) toggleFullTextForMobile();
    },
    [router, toggleFullTextForMobile]
  );

  return (
    <form
      className="navbar-form form-inline"
      id="autocomplete"
      ref={ref}
      onSubmit={handleSubmit}
      style={{ flexGrow: 1, position: 'relative' }}
    >
      <input
        type="text"
        id="searchBondFullText"
        className={`form-control ms-lg-5  ${!!isMobile ? 'p-4 shadow-100vh rounded' : ''}`}
        autoComplete="off"
        onChange={handleFullTextSearch}
        onClick={handleClickFulltext}
        placeholder={placeholder} // Set the placeholder attribute to the state variable
        autoFocus={!!isMobile}
        onFocus={handleInputFocus}
        style={{ height: '30px', borderRadius: '.1rem', fontSize: '12px' }}
        aria-describedby="search-icon"
        name="value"
        value={value}
        disabled={isBoandsLoader}
      />
      <button id="myButton" type="submit" className="d-none" />
      {showDropdown && !!value.trim() && (
        <div className={`select-dropdown-ul searchBondFullTextwidth ms-lg-5 shadow ${!!isMobile ? 'mx-2 me-3' : ''}`}>
          {loading && !!value.trim() ? (
            <FullTextLazyLoading />
          ) : data?.length === 0 ? (
            <h6 className="text-center mt-5 text-muted">No Data Found!</h6>
          ) : (
            <div>
              {data?.map((item: any) => {
                return (
                  <div className="mt-2 fulltext_search_dropdown_styles px-1" key={item?.isin}>
                    <p className="mb-0 text-primary  cursor-pointer" onClick={() => handleBondNameClick(item.isin)}>
                      {item?.bond_name}
                    </p>
                    <p className="mb-0  text-muted d-flex gap-1">
                      {item?.country_name} | {item?.coupon ? item.coupon + '%' : 'NA'} |{' '}
                      <span className="text-truncate " title={item?.issuer} style={{ width: '180px' }}>
                        {' '}
                        {item?.issuer}
                      </span>
                    </p>
                  </div>
                );
              })}
              <div className="more-results-button-container">
                <button onClick={handleSubmit} type="button" className="btn btn-link more-results-button">
                  More results...
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </form>
  );
};
const mapStatesToProps = ({
  bonds: { bondsData = {}, isBoandsLoader = false, isBoandsFullTextHandle = false, bondsFulltextHandle = {} },
}: any) => {
  return {
    bondsData,
    isBoandsLoader,
    isBoandsFullTextHandle,
    bondsFulltextHandle,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      ...bondsAction,
    },
    dispatch
  );
};

export default memo(connect(mapStatesToProps, mapDispatchToProps)(FullTextSearch));
